<template>
  <section class="d-flex flex-column h-full">
    <div class="mdc-top-app-bar__row shadow">
      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start t-color-red3">
          <a
            class="material-icons blue0006 mdc-top-app-bar__navigation-icon"
            @click="$router.go(-1)"
          >arrow_back</a>
        </section>

      <section class="mdc-top-app-bar__section title">
        <div class="mdc-top-app-bar__title">{{ $t('1723') }}</div>
      </section>

      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end t-color-red3">
        <a class="material-icons blue0006 mdc-top-app-bar__navigation-icon"></a>
      </section>
    </div>
    <div id="tab1" class="t-color-gray2">
      <div class="pda-default d-flex listItems border-bottom">
        <div
          class="w-40 h-40 t-headline7 iconHolder min-w-40 t-color-white font-r d-flex justify-content-center align-items-center"
        >
          <i class="material-icons font-20">photo_camera</i>
        </div>
        <div>
          <div class="t-color-title t-body1 l-spacing48 pdl-16 pdr-16 font-r">{{ $t('1724') }}</div>
          <div class="t-color-content1 t-body4 l-spacing6 pdl-16 pdt-8 font-r">{{ $t('1725') }}</div>
          <div class="t-color-content1 t-body4 l-spacing48 pdl-16 pdt-8 font-r">{{ $t('1725') }}</div>
        </div>
      </div>
      <div class="pda-default d-flex listItems border-bottom">
        <div
          class="w-40 h-40 t-headline7 iconHolder min-w-40 t-color-white font-r d-flex justify-content-center align-items-center"
        >
          <i class="material-icons font-20">backup</i>
        </div>
        <div>
          <div class="t-color-title t-body1 l-spacing48 pdl-16 pdr-16 font-r">{{ $t('1727') }}</div>
          <div class="t-color-content1 t-body4 l-spacing6 pdl-16 pdt-8 font-r">{{ $t('1728') }}</div>
        </div>
      </div>
      <div class="t-color-content1 t-body4 l-spacing6 pda-default font-r">{{ $t('1729') }}</div>
    </div>
  </section>
</template>

<style scoped>
.shadow {
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
.border-bottom {
  border-bottom: 1px solid #e6eced;
}

.iconHolder {
  background: #acb4be;
  border-radius: 50%;
}
</style>

<script>
export default {};
</script>